<div in:AnimIN out:AnimOUT on:click class="card text" class:picked class:disposalMode class:pickedForDisposal>
    ...{replaceText(card.text, players)}
</div>

<style>
.card{
    font-size: 1.5em;
    padding: 1em 1em;
    border-radius: 50px;
    margin-bottom: 10px;
    color: #fff;
    cursor: pointer;
    background: linear-gradient(0deg, var(--tera), var(--giga), var(--kilo), var(--mega));
    background-size: 100% 200%;
    box-shadow: 10px 10px 29px #d3801a;
    transition: background-position 200ms ease-in-out;
    background-position: 0% 0%;
}
.picked {
    background-position: 0 100%;
}
.disposalMode{
    background: linear-gradient(45deg, var(--zetta), var(--yotta));
}
.pickedForDisposal{
    background: linear-gradient(270deg, var(--kilo), var(--mega));
}
@media screen and (max-width: 1000px) {
    .card{
        font-size: 1.3em;
        border-radius: 30px;
        padding: .7em .7em;
    }
}
</style>

<script>
import { AnimIN, AnimOUT } from "../../code/anim.js"

export let card
export let players
export let picked = false
export let disposalMode = false
export let pickedForDisposal = false

import { replaceText } from "../../code/replaceText"
</script>